import { useQuery as useTanStackQuery } from '@tanstack/react-query';

import { getWelcome } from 'services/RequestService/endpoints/signUp';

const useWelcomeQuery = mealPlan => {
  return useTanStackQuery({
    queryKey: ['welcome', { mealPlan }],
    queryFn: ({ queryKey }) => {
      const [, { mealPlan }] = queryKey;
      return getWelcome({ params: { mealPlan: mealPlan } });
    },
    staleTime: 1000 * 60 * 10, // Read from cache for 10 minutes
    enabled: mealPlan !== null, // Only run the query if mealPlan is not null
  });
};

export default useWelcomeQuery;
